import { prompt, type PromptDefinition } from './models';

export const ARCHITECT_PROMPTS = [
    prompt(
        'Plan change',
        'Which drawings describe the existing layout of this building?',
        'Which buildings lack a reliable set of existing-layout drawings?'
    ),
    prompt(
        'Plan change',
        'What design constraints are recorded for this building?',
        'Compare documented design constraints across my buildings.'
    ),
    prompt(
        'Meet obligations',
        "Which approvals relate to this building's current design?",
        'Which buildings have gaps between their drawings and available approvals?'
    ),
    prompt(
        'Plan change',
        'Find drawings for this building showing…',
        'Find drawings across my buildings showing…',
        'prefill'
    ),
    prompt(
        'Plan change',
        'Which drawing revisions are available for this building, and which are latest?',
        'Which buildings have drawing revision conflicts to resolve?'
    ),
    prompt(
        'Manage risk',
        "What do the fire strategy documents require for this building's design?",
        'Compare documented fire strategy constraints across my buildings.'
    ),
    prompt(
        'Plan change',
        'What accessibility findings should inform design work on this building?',
        'Which buildings have accessibility findings relevant to upcoming design work?'
    ),
    prompt(
        'Plan change',
        'Find material specifications for this building covering…',
        'Find material specifications across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Plan change',
        'What services or structural constraints are documented for this building?',
        'Which buildings need further services or structural information before design?'
    ),
    prompt(
        'Improve performance',
        'What environmental performance targets are documented for this building?',
        'Compare documented environmental design targets across my buildings.'
    ),
    prompt(
        'Plan change',
        "Which design questions remain unresolved in this building's reports?",
        'Which buildings have unresolved design questions that could hold up work?'
    ),
    prompt(
        'Plan change',
        'Trace design changes for this building relating to…',
        'Compare design changes across my buildings relating to…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
